import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const { setPickupPersonFormField } = props

    const onChangeFormField = fieldName => event =>{
      setPickupPersonFormField(fieldName, event.target.value)
    }

    return <WrappedComponent onChangeFormField={onChangeFormField} {...props} />
  }
}

export default withEventHandlers
